module.exports = __webpack_public_path__ + "img/react.3fe34653.png";